import React from 'react';
import { Link } from 'react-router-dom';

import ScrollReveal from '../../components/ScrollReveal';

import Mission from '../../assets/about_images/Mission.jpg';
import Milestones from '../../assets/about_images/Milestones.jpg';

function About() {
  const milestones = [
    {
      year: "2018",
      items: ["Launch of Value Agility workshop"],
    },
    {
      year: "2019",
      items: [
        "Launch of Money Glow The Series",
        "Enterprise Wealth workshop – เศรษฐีเรือนใน",
        "The Inner Wealth workshop – เศรษฐีเรือนนอก",
      ],
    },
    {
      year: "2022",
      items: ["The InnerWealth Playbook (Thai version)"],
    },
    {
      year: "2024",
      items: [
        `"WealthyCats" board game premiere launch at Bank of Thailand Learning Center`,
        `Launch of "WealthyCats WealthyClass"`,
        `Inaugural "Wealthy Owls – Happy Retirement" workshop`,
        `MoU signing with Thammasat University Library for Life-long Learning Program initiative.`,
      ],
    },
    {
      year: "2025",
      items: [
        "Financial literacy project for youth and communities Project.",
        `Collaboration with Bank of Thailand Learning Center on children's financial education (โครงการ "สอนหนูรู้เรื่องเงิน")`,
        `Launch of "WealthyCats and The Inner Wealth Playbook" (English edition of เศรษฐีเรือนใน)`,
        `"Train the Trainer" program for 20 educators and community activists/leaders`,
      ],
    },
  ];

  const pillars = [
    {
      iconPath: 'M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9',
      title: 'Leadership',
      text: 'Igniting the confidence to lead, decide, and inspire others.',
    },
    {
      iconPath: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z',
      title: 'Teamwork',
      text: 'Learning together through play, collaboration, and shared goals.',
    },
    {
      iconPath: 'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z',
      title: 'Entrepreneurship',
      text: 'Cultivating creative thinking and an opportunity-seeking mindset.',
    },
    {
      iconPath: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
      title: 'Financial Mindset',
      text: 'Building lifelong money skills that turn planning into a joyful habit.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[70vh] sm:h-[80vh] flex items-center justify-center">
        {/* Background image */}
        <img
          src={Mission}
          alt="H Academy workshop and community impact"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black/50"></div>

        {/* Content */}
        <div className="relative z-10 max-w-4xl mx-auto text-center px-6">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-6">
            About H Academy
          </h1>

          <p className="text-lg sm:text-xl text-gray-100 leading-relaxed">
            A social enterprise igniting leadership, teamwork, and financial mindsets
            through the joy of play — since 2018.
          </p>
        </div>
      </section>

      {/* Floating Stats Card */}
      <section className="relative z-20 -mt-14 sm:-mt-16 pb-4">
        <div className="container-custom">
          <ScrollReveal>
            <div className="max-w-5xl mx-auto bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl p-6 sm:p-8 border border-white/40">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
                <div className="text-center">
                  <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#F4900C] mb-1">2018</div>
                  <div className="text-gray-600 font-medium text-xs sm:text-sm md:text-base">Founded</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#F4900C] mb-1">1,000+</div>
                  <div className="text-gray-600 font-medium text-xs sm:text-sm md:text-base">Children Reached</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#F4900C] mb-1">20+</div>
                  <div className="text-gray-600 font-medium text-xs sm:text-sm md:text-base">Schools & Partners</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#F4900C] mb-1">iF Award</div>
                  <div className="text-gray-600 font-medium text-xs sm:text-sm md:text-base">Social Impact 2025</div>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container-custom">
          <div className="max-w-5xl mx-auto">
            <ScrollReveal>
              <div className="text-center mb-12">
                {/* Eyebrow */}
                <div className="flex justify-center mb-4">
                  <span className="inline-flex items-center gap-2 text-xs sm:text-sm font-semibold tracking-widest uppercase text-[#F4900C]">
                    <span className="h-px w-8 bg-[#F4900C]/40"></span>
                    Our Mission
                    <span className="h-px w-8 bg-[#F4900C]/40"></span>
                  </span>
                </div>

                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6">
                  Learning should be{' '}
                  <span className="text-[#F4900C]">joyful</span>, interactive, and{' '}
                  <span className="text-[#F4900C]">transformative</span>
                </h2>

                <p className="text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
                  <span className="text-[#F4900C] font-bold">H Academy</span> ignites leadership,
                  fosters teamwork, and cultivates entrepreneurial and financial mindsets through our
                  unique "Play & Learn" and "Action Learning" style workshops since 2018.
                </p>
              </div>
            </ScrollReveal>

            {/* Pillar Cards */}
            <ScrollReveal delay={150}>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {pillars.map((pillar, idx) => (
                  <div
                    key={idx}
                    className="group bg-gradient-to-br from-yellow-50 to-orange-50 rounded-2xl p-6 border border-orange-100 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 text-center"
                  >
                    <div className="w-14 h-14 mx-auto mb-4 bg-gradient-to-br from-[#FED700] to-[#F4900C] rounded-xl shadow flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <svg className="w-7 h-7 text-gray-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={pillar.iconPath} />
                      </svg>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-[#F4900C] transition-colors">
                      {pillar.title}
                    </h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {pillar.text}
                    </p>
                  </div>
                ))}
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* Social Enterprise Section — dark band */}
      <section className="py-16 md:py-24 bg-gray-900 relative overflow-hidden">
        {/* Decorative glow */}
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#FED700]/10 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#F4900C]/10 rounded-full filter blur-3xl"></div>

        <div className="container-custom relative z-10">
          <div className="max-w-5xl mx-auto">
            <ScrollReveal>
              <div className="text-center mb-12">
                <div className="inline-flex items-center gap-3 bg-gradient-to-r from-[#FED700] to-[#F4900C] px-6 py-3 rounded-full mb-6 shadow-lg">
                  <svg className="w-6 h-6 text-gray-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                  </svg>
                  <span className="font-bold text-gray-900 text-lg">Registered Social Enterprise</span>
                </div>

                <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                  Committed to{' '}
                  <span className="bg-gradient-to-r from-[#FED700] to-[#F4900C] bg-clip-text text-transparent">
                    Sustainable Impact
                  </span>
                </h2>
                <p className="text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto">
                  We are proud to announce that{' '}
                  <span className="text-[#FED700] font-bold">H Academy</span> is now a registered
                  Social Enterprise, reinforcing our commitment to sustainable impact and equitable education.
                </p>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={150}>
              <div className="grid md:grid-cols-2 gap-6">
                {/* Official Registration */}
                <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:border-[#FED700]/40 transition-colors duration-300">
                  <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-3">
                    <span className="w-10 h-10 bg-gradient-to-br from-[#FED700] to-[#F4900C] rounded-lg flex items-center justify-center">
                      <svg className="w-5 h-5 text-gray-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                      </svg>
                    </span>
                    Official Registration
                  </h3>
                  <div className="space-y-4 text-gray-300">
                    <p className="flex items-start gap-3">
                      <span className="text-[#FED700] font-bold">•</span>
                      <span><strong className="text-white">Registered Name:</strong> Team H Is Happy Co., Ltd. Social Enterprise</span>
                    </p>
                    <p className="flex items-start gap-3">
                      <span className="text-[#FED700] font-bold">•</span>
                      <span><strong className="text-white">Registration Number:</strong> 335</span>
                    </p>
                    <p className="flex items-start gap-3">
                      <span className="text-[#FED700] font-bold">•</span>
                      <span><strong className="text-white">Date:</strong> November 2024</span>
                    </p>
                  </div>
                </div>

                {/* What This Means */}
                <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:border-[#FED700]/40 transition-colors duration-300">
                  <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-3">
                    <span className="w-10 h-10 bg-gradient-to-br from-[#FED700] to-[#F4900C] rounded-lg flex items-center justify-center">
                      <svg className="w-5 h-5 text-gray-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                      </svg>
                    </span>
                    What This Means
                  </h3>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    As a registered social enterprise, we are legally committed to creating positive
                    social impact alongside financial sustainability.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    This status validates our mission to make quality financial education accessible
                    to all, especially underserved communities.
                  </p>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* Journey Banner — parallax image band */}
      <section
        className="relative h-[40vh] min-h-[300px] flex items-center justify-center overflow-hidden bg-cover bg-center md:bg-fixed"
        style={{ backgroundImage: `url(${Milestones})` }}
      >
        <div className="absolute inset-0 bg-black/55"></div>
        <div className="relative z-10 text-center px-6">
          <div className="flex justify-center mb-4">
            <span className="inline-flex items-center gap-2 text-xs sm:text-sm font-semibold tracking-widest uppercase text-[#FED700]">
              <span className="h-px w-8 bg-[#FED700]/60"></span>
              Our Journey
              <span className="h-px w-8 bg-[#FED700]/60"></span>
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white drop-shadow-2xl">
            Milestones That{' '}
            <span className="bg-gradient-to-r from-[#FED700] to-[#F4900C] bg-clip-text text-transparent">
              Shaped Us
            </span>
          </h2>
        </div>
      </section>

      {/* Timeline Section — alternating on desktop */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container-custom">
          <div className="max-w-5xl mx-auto">
            <div className="relative">
              {/* Vertical line: left on mobile, centered on desktop */}
              <div className="absolute left-5 md:left-1/2 md:-translate-x-1/2 top-0 h-full w-px bg-gradient-to-b from-[#FED700]/70 via-[#F4900C]/70 to-[#F4900C]/30" />

              <div className="space-y-10 md:space-y-14">
                {milestones.map((milestone, idx) => (
                  <ScrollReveal key={idx}>
                    <div className="relative group">
                      {/* Dot */}
                      <div className="absolute left-3 md:left-1/2 md:-translate-x-1/2 top-6 z-10">
                        <div className="relative">
                          <div className="absolute inset-0 rounded-full animate-ping bg-[#F4900C]/30" />
                          <div className="relative w-4 h-4 rounded-full bg-[#F4900C] border-4 border-[#F4900C] transition-all duration-300 group-hover:scale-125 group-hover:shadow-[0_0_15px_#F4900C]" />
                        </div>
                      </div>

                      {/* Card — alternates sides on desktop */}
                      <div
                        className={`pl-14 md:pl-0 md:w-[calc(50%-3rem)] ${
                          idx % 2 === 0 ? 'md:mr-auto' : 'md:ml-auto'
                        }`}
                      >
                        <div className="bg-white rounded-xl p-6 border-2 border-[#F4900C]/20 shadow-md transition-all duration-300 group-hover:shadow-xl group-hover:border-[#F4900C]/50 group-hover:-translate-y-1">
                          <span className="inline-block bg-gradient-to-r from-[#FED700] to-[#F4900C] text-gray-900 font-bold text-sm px-4 py-1 rounded-full mb-4 shadow">
                            {milestone.year}
                          </span>

                          <ul className="space-y-2">
                            {milestone.items.map((item, i) => (
                              <li
                                key={i}
                                className="text-gray-700 leading-relaxed flex gap-3 transition-colors duration-300 group-hover:text-gray-900"
                              >
                                <span className="text-[#F4900C] font-bold">•</span>
                                <span>{item}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </ScrollReveal>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section — gradient band */}
      <section className="py-16 md:py-20 bg-gradient-to-r from-[#FED700] to-[#F4900C] relative overflow-hidden">
        {/* Decorative circles */}
        <div className="absolute -top-16 -left-16 w-64 h-64 bg-white/10 rounded-full"></div>
        <div className="absolute -bottom-20 -right-10 w-80 h-80 bg-white/10 rounded-full"></div>

        <div className="container-custom relative z-10">
          <ScrollReveal>
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                Let's Build Financial Confidence Together
              </h2>
              <p className="text-xl text-gray-800 mb-10">
                Explore our programs or get in touch with our team
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  to="/academy"
                  className="bg-gray-900 text-white hover:bg-gray-800 font-bold py-4 px-8 rounded-lg hover:shadow-xl transition-all duration-300 text-lg transform hover:-translate-y-0.5"
                >
                  View Our Programs
                </Link>
                <Link
                  to="/organization/team"
                  className="bg-white text-gray-900 hover:bg-gray-100 font-semibold py-4 px-8 rounded-lg text-lg shadow transition-all duration-300 transform hover:-translate-y-0.5"
                >
                  Meet Our Team
                </Link>
                <Link
                  to="/contact"
                  className="bg-transparent border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white font-semibold py-4 px-8 rounded-lg text-lg transition-all duration-300"
                >
                  Contact Us
                </Link>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>
    </div>
  );
}

export default About;
